import { api } from '../../api'
import type {
  SubscriptionListDTO,
  SubscriptionStatus,
  SubscriptionPlan,
} from '@/types/admin'

export interface SubscriptionsPageResponse {
  content: SubscriptionListDTO[]
  totalElements: number
  totalPages: number
  size: number
  number: number
}

/**
 * Get paginated list of subscriptions with optional filters
 */
export async function getSubscriptions(params: {
  page?: number
  size?: number
  status?: SubscriptionStatus
  plan?: SubscriptionPlan
  restaurantName?: string
}): Promise<SubscriptionsPageResponse> {
  const response = await api.get<SubscriptionsPageResponse>('/api/admin/subscriptions', { params })
  return response.data
}

/**
 * Get subscriptions expiring soon (within 30 days)
 */
export async function getExpiringSoon(): Promise<SubscriptionListDTO[]> {
  const response = await api.get<SubscriptionListDTO[]>('/api/admin/subscriptions/expiring-soon')
  return response.data
}
